module.exports = __webpack_public_path__ + "img/molly.998ee146.jpg";